// extracted by mini-css-extract-plugin
export default {"innerContainer":"u8j4Qp","topDivider":"wmY2be","title":"Zaq83k","text":"c3e2SA","buttons":"txsdzz","button":"j_4Lql"};